module.exports = __webpack_public_path__ + "img/footerIcon.357b9368.svg";